import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Spinner from 'react-bootstrap/Spinner';
import { FaEyeSlash } from 'react-icons/fa';

// import React, { useEffect, useState } from 'react';
// import Navigation from '../components/Navigation';
// import { NavLink } from 'react-router-dom';
// import base_url from '../config/Config';
// import axios from "axios";
// import Sidebar from '../components/Sidebar';
// import Spinner from 'react-bootstrap/Spinner';
// import { FaEyeSlash } from 'react-icons/fa';

// const Collection = () => {
//     const [collection, setCollection] = useState([]);
//     const [isDownloading, setIsDownloading] = useState(false);
//     const [searchOption, setSearchOption] = useState('');
//     const [searchInput, setSearchInput] = useState('');
//      const [currentPage, setCurrentPage] = useState(1);
    
//             const collectionPerPage = 50;


//     const getAllCollection = () => {
//         axios.get(`${base_url}/api/repayment/collection`).then(
//             (response) => {
//                 console.log(response.data);
//                 setCollection(response.data);
//             },
//             (error) => {
//                 console.log(error);
//             }
//         );
//     };

//     useEffect(() => {
//         getAllCollection();
//     }, []);

//     const handleSearch = (event) => {
//         event.preventDefault();
//         if (searchOption && searchInput) {
//             let url = '';
//             switch (searchOption) {
//                 case 'Fintech':
//                     url = `${base_url}/api1/user/searchByPartnerName?partnerName=${searchInput}`;
//                     break;
//                 case 'gst':
//                     url = `${base_url}/api1/user/searchByGst?gst=${searchInput}`;
//                     break;
//                 case 'phone':
//                     url = `${base_url}/api1/user/searchByPhone?phone=${searchInput}`;
//                     break;
//                 default:
//                     break;
//             }
//             axios.get(url).then(
//                 (response) => {
//                     console.log(response.data);
//                     setCollection(response.data);
//                 },
//                 (error) => {
//                     console.log(error);
//                 }
//             );
//         }
//     };

//     const handleExportCollection = async () => {
//         setIsDownloading(true);
//         try {
//             const response = await axios.get(`${base_url}/api/export/collection`, {
//                 responseType: 'blob'
//             });
//             const url = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'Collection_Data.xlsx');
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             console.log('Export Collection successfully:', response.data);
//             alert('Export Collection successfully');
//         } catch (error) {
//             console.error('Error generating repayment:', error.response?.data || error.message);
//             alert('Export Collection not shown');
//         } finally {
//             setIsDownloading(false);
//         }
//     };

    
//     const indexOfLastCollection = currentPage * collectionPerPage;
//     const indexOfFirstCollection = indexOfLastCollection - collectionPerPage;
//     const collections = collection.slice(indexOfFirstCollection, indexOfLastCollection);
//     const totalPages = Math.ceil(collection.length / collectionPerPage);
//     const maxPageButtons = 10;

//     const getPaginationRange = () => {
//         const mid = Math.floor(maxPageButtons / 2);
//         let start = Math.max(1, currentPage - mid);
//         let end = Math.min(totalPages, start + maxPageButtons - 1);
//         if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
//         return { start, end };
//     };

//     const { start: startPage, end: endPage } = getPaginationRange();



//     return (
//         <>
//             <div className='overviewsaa'>
//                 <h4>All Collection</h4>
//             </div>
//             <div className='navigationss mb-5'>
//                 <Navigation />
//             </div>
//             <div className='container-fluid'>
//                 <div className='row'>
//                     <div className='col-lg-2 col-md-2 sidebarnavigartion'>
//                         <div className='lmssidebar'>
//                             <Sidebar />
//                         </div>
//                     </div>
//                     <div className='col-lg-10 col-md-10'>
//                         <div className='dashboardlms  mt-5 text-center'>
//                             <div className='row'>
//                                 <div className='col-md-12'>
//                                     <div className='searchtoll'>
//                                         <form onSubmit={handleSearch}>
//                                             <div className='row'>
//                                                 <div className="col-md-3 col-3">
//                                                     <div className=" required">
//                                                         <select name="option" id="option" className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required="required">
//                                                             <option value="" selected="selected">Search By</option>
//                                                             <option value="Fintech">Fintech Partner</option>
//                                                             <option value="gst">GST Number</option>
//                                                             <option value="phone">Phone</option>
//                                                         </select>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-5 col-6">
//                                                     <div className=" required">
//                                                         <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required />
//                                                     </div>
//                                                 </div>

//                                                 <div className="col-md-2 col-3">
//                                                     <div className=" required">
//                                                         <button type="submit" className="btn btn-sm btn-primary">Search</button>
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-2 mt-2'>
//                                                     <div className='export'>
//                                                         <NavLink to="#" className="exportbutton" onClick={handleExportCollection}>
//                                                             {isDownloading ? (
//                                                                 <Spinner animation="border" size="sm" />
//                                                             ) : (
//                                                                 <>
//                                                                     Download
//                                                                 </>
//                                                             )}
//                                                         </NavLink>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </form>
//                                     </div>
//                                 </div>
//                                 <div className='col-md-12 col-lg-12'>
//                                     <div className='allcustomer table-responsive table-striped mb-5 mt-3'>
//                                         { pageLoading ? <PageLoader text="Loading..." /> : collections.length > 0  ? (
//                                             <table className="styled-table">
//                                                 <tbody>
//                                                     <tr>
//                                                         <th>Repayment_Id</th>
//                                                         <th>Loan_Id</th>
//                                                         <th>Customer_Id</th>
//                                                         <th>EMI_Due_Date</th>
//                                                         <th>EMI_Number</th>
//                                                         <th>EMI_Amount</th>
//                                                         <th>Principal</th>
//                                                         <th>Interest</th>
//                                                         <th>Create_Date</th>
//                                                         <th>Update_Date</th>
//                                                         <th>Status</th>
//                                                         <th>Action</th>
//                                                     </tr>
//                                                     {collections.map((data, index) => (
//                                                         <tr key={index}>
//                                                             <td>{data.id}</td>
//                                                             <td>{data.loanId}</td>
//                                                             <td>{data.customerId}</td>
//                                                             <td>{data.installmentDate}</td>
//                                                             <td>{data.installmentNumber}</td>
//                                                             <td>{data.emiAmount}</td>
//                                                             <td>{data.principal}</td>
//                                                             <td>{data.interest}</td>
//                                                             <td>{data.createDate ? new Date(data.createDate).toLocaleDateString() : ''}</td>
//                                                             <td>{data.updateDate ? new Date(data.updateDate).toLocaleDateString() : ''}</td>
//                                                             {/* <td>{data.emiStatus === 0 ? 'Pending' : data.emiStatus === 1 ? 'Paid' : 'Unknown'}</td> */}
//                                                             <td style={{ color: data.emiStatus === 1 ? 'green' : data.emiStatus === 0 ? 'black' : 'red', fontWeight: '700' }}>{data.emiStatus === 0 ? 'Pending' : data.emiStatus === 1 ? 'Paid' : 'Unknown'}</td>
//                                                             <td className='iconss'>
//                                                                 <NavLink to={`/loanmaster/ViewLoan?customerId=${data.customerId}&loanId=${data.loanId}`}>
//                                                                     <FaEyeSlash />
//                                                                 </NavLink>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                             </table>
//                                         ) : (
//                                             "No Collection Data"
//                                         )}
//                                     </div>
//                                     <div className="pagination-container">
//                                         <div className="pagination-box">
//                                             {startPage > 1 && (
//                                                 <>
//                                                     <button onClick={() => setCurrentPage(1)}>1</button>
//                                                     <span className="dots">...</span>
//                                                 </>
//                                             )}
//                                             {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
//                                                 <button
//                                                     key={startPage + i}
//                                                     className={currentPage === startPage + i ? 'active' : ''}
//                                                     onClick={() => setCurrentPage(startPage + i)}
//                                                 >
//                                                     {startPage + i}
//                                                 </button>
//                                             ))}
//                                             {endPage < totalPages && (
//                                                 <>
//                                                     <span className="dots">...</span>
//                                                     <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
//                                                 </>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Collection;




const Collection = () => {
  const [collection, setCollection] = useState([]);
  const [filteredCollection, setFilteredCollection] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [searchOption, setSearchOption] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const collectionPerPage = 50;

  // ✅ Fetch All Collection
  const getAllCollection = async () => {
    try {
      const response = await axios.get(`${base_url}/api/repayment/collection`);
      setCollection(response.data);
      setFilteredCollection(response.data);
    } catch (error) {
      console.log('Error fetching collection:', error);
    }
  };

  useEffect(() => {
    getAllCollection();
  }, []);

  // ✅ Handle Search (client-side filtering)
  const handleSearch = (event) => {
    event.preventDefault();
    let filtered = [...collection];

    if (searchOption && searchInput) {
      switch (searchOption) {
        case 'emi_amount':
          filtered = filtered.filter((item) =>
            item.emiAmount?.toString().toLowerCase().includes(searchInput.toLowerCase())
          );
          break;
        case 'loan_id':
          filtered = filtered.filter((item) => item.loanId?.toString() === searchInput);
          break;
        case 'customer_id':
          filtered = filtered.filter((item) => item.customerId?.toString() === searchInput);
          break;
        case 'emi_id':
          filtered = filtered.filter((item) => item.id?.toString().includes(searchInput));
          break;
        default:
          break;
      }
    } else {
      filtered = [...collection];
    }

    setFilteredCollection(filtered);
    setCurrentPage(1);
  };

  // ✅ Handle Excel Export
  const handleExportCollection = async () => {
    setIsDownloading(true);
    try {
      const response = await axios.get(`${base_url}/api/export/collection`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Collection_Data.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      alert('Exported Collection Successfully');
    } catch (error) {
      console.error('Error exporting collection:', error);
      alert('Error exporting collection');
    } finally {
      setIsDownloading(false);
    }
  };

  // ✅ Pagination
  const indexOfLastCollection = currentPage * collectionPerPage;
  const indexOfFirstCollection = indexOfLastCollection - collectionPerPage;
  const collections = filteredCollection.slice(indexOfFirstCollection, indexOfLastCollection);
  const totalPages = Math.ceil(filteredCollection.length / collectionPerPage);
  const maxPageButtons = 10;

  const getPaginationRange = () => {
    const mid = Math.floor(maxPageButtons / 2);
    let start = Math.max(1, currentPage - mid);
    let end = Math.min(totalPages, start + maxPageButtons - 1);
    if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
    return { start, end };
  };

  const { start: startPage, end: endPage } = getPaginationRange();

  return (
    <>
      <div className="overviewsaa">
        <h4>All Collection</h4>
      </div>

      <div className="navigationss mb-5">
        <Navigation />
      </div>

      <div className="container-fluid">
        <div className="row">
          {/* Sidebar */}
          <div className="col-lg-2 col-md-2 sidebarnavigartion">
            <div className="lmssidebar">
              <Sidebar />
            </div>
          </div>

          <div className="col-lg-10 col-md-10">
            <div className="dashboardlms text-center">
              {/* Search Bar */}
              <div className="row">
                <div className="col-md-12">
                  <div className="searchtoll">
                    <form onSubmit={handleSearch}>
                      <div className="row">
                        <div className="col-md-2">
                          <select
                            className="form-control"
                            value={searchOption}
                            onChange={(e) => setSearchOption(e.target.value)}
                          >
                            <option value="">Search By</option>
                            <option value="emi_amount">EMI Amount</option>
                            <option value="loan_id">Loan ID</option>
                            <option value="customer_id">Customer ID</option>
                            <option value="emi_id">EMI ID</option>
                          </select>
                        </div>

                        <div className="col-md-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                          />
                        </div>

                        <div className="col-md-1">
                          <button type="submit" className="btn btn-sm btn-primary">
                            Search
                          </button>
                        </div>

                        <div className="col-md-2 mt-2">
                          <div className="export">
                            <NavLink to="#" className="exportbutton" onClick={handleExportCollection}>
                              {isDownloading ? <Spinner animation="border" size="sm" /> : 'Download'}
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                {/* Table */}
                <div className="col-md-12 col-lg-12">
                  <div className="allcustomer table-responsive table-striped mb-5 mt-3">
                    {collections.length > 0 ? (
                      <table className="styled-table">
                        <thead>
                          <tr>
                            <th>Repayment_Id</th>
                            <th>Loan_Id</th>
                            <th>Customer_Id</th>
                            <th>EMI_Due_Date</th>
                            <th>EMI_Number</th>
                            <th>EMI_Amount</th>
                            <th>Principal</th>
                            <th>Interest</th>
                            <th>Create_Date</th>
                            <th>Update_Date</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {collections.map((data, index) => (
                            <tr key={data.id || index}>
                              <td>{data.id}</td>
                              <td>{data.loanId}</td>
                              <td>{data.customerId}</td>
                              <td>{data.installmentDate}</td>
                              <td>{data.installmentNumber}</td>
                              <td>{data.emiAmount}</td>
                              <td>{data.principal}</td>
                              <td>{data.interest}</td>
                              <td>{data.createDate ? new Date(data.createDate).toLocaleDateString() : ''}</td>
                              <td>{data.updateDate ? new Date(data.updateDate).toLocaleDateString() : ''}</td>
                              <td
                                style={{
                                  color:
                                    data.emiStatus === 1
                                      ? 'green'
                                      : data.emiStatus === 0
                                      ? 'black'
                                      : 'red',
                                  fontWeight: '700',
                                }}
                              >
                                {data.emiStatus === 0
                                  ? 'Pending'
                                  : data.emiStatus === 1
                                  ? 'Paid'
                                  : 'Unknown'}
                              </td>
                              <td className="iconss">
                                <NavLink
                                  to={`/loanmaster/ViewLoan?customerId=${data.customerId}&loanId=${data.loanId}`}
                                >
                                  <FaEyeSlash />
                                </NavLink>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p>No Collection Data Found</p>
                    )}
                  </div>

                  {/* Pagination */}
                  <div className="pagination-container">
                    <div className="pagination-box">
                      {startPage > 1 && (
                        <>
                          <button onClick={() => setCurrentPage(1)}>1</button>
                          <span className="dots">...</span>
                        </>
                      )}

                      {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                        <button
                          key={startPage + i}
                          className={currentPage === startPage + i ? 'active' : ''}
                          onClick={() => setCurrentPage(startPage + i)}
                        >
                          {startPage + i}
                        </button>
                      ))}

                      {endPage < totalPages && (
                        <>
                          <span className="dots">...</span>
                          <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Collection;
